import Icon from '../../Icon/Icon';
import { IconKeys } from '../../Icon/IconKeys';
import S from './ProceedToDetailsStyles';

function ProceedToDetails():JSX.Element {
  return (
    <S.Wrapper className="button-container">
      <Icon iconKey={IconKeys.ARROW_RIGHT} />
    </S.Wrapper>
  );
}

export default ProceedToDetails;
